export const upcomingFeatures = [
  {
    title: 'Modify and Delete Sessions',
    description: 'The ability to edit past training sessions, as well as delete them entirely',
  },
  {
    title: 'Expanded analytics',
    description: 'A more customizable graphic dashboard to provide training insights',
  },
  {
    title: 'Activity Tagging',
    description: 'Ability to log related tags to activities (i.e. logging specific forms or PAs worked on)',
  },
  {
    title: 'Add Role Indicator to Training Sessions',
    description: 'Allow users to indicate whether a session was attended as a student or taught as a teacher'
  },
  {
    title: 'Color/Theme improvement',
    description: 'Optimize theme colors in all charts'
  },
  {
    title: 'Email Insights',
    description: 'Automated monthly and annual emails with training insights'
  }
];
